import { toast } from "@/components/Toast";
import { cancelAllTask } from "@/utils/batchTask";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import {
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";

const CancelTaskRemind: React.FC<{
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  remindText?: string;
  confirmText?: string;
  cancelText?: string;
}> = ({ open, onClose, onCancel, onConfirm, remindText, confirmText, cancelText }) => {
  const { translate } = useTranslate();
  async function handleConfirm() {
    cancelAllTask()
      .then(() => {
        onConfirm?.();
      })
      .catch(() => {
        onConfirm?.();
        toast({
          status: "error",
          title: translate(Editor_Words["cancel_tasks_failed"]),
          position: "top",
        });
      });
  }
  return (
    <Modal isOpen={open} onClose={onClose} isCentered variant="dark" size="md">
      <ModalOverlay></ModalOverlay>
      <ModalContent>
        <ModalCloseButton top="14px" right="14px" />
        <ModalBody>
          <Center flexDir="column" w="100%" pt="55px" pb="37px">
            <Text fontSize="18px">
              {remindText ?? translate(Editor_Words["replace_cancel_task_tip"])}
            </Text>
            <Center mt="41px">
              <Button onClick={onCancel} w="120px" mr="16px">
                {cancelText ?? translate(Editor_Words["replace_cancel_tasks_cancel"])}
              </Button>
              <Button
                onClick={handleConfirm}
                w="120px"
                variant="dark.solid"
                bg="#434343"
                color="text.lightDisabled"
              >
                {confirmText ?? translate(Editor_Words["replace_cancel_tasks_confirm"])}
              </Button>
            </Center>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export const ReplaceProjectCancelTaskRemind = observer(CancelTaskRemind);
